import { render, staticRenderFns } from "./DigitalVotingEvent.vue?vue&type=template&id=2118d108"
import script from "./DigitalVotingEvent.vue?vue&type=script&lang=js"
export * from "./DigitalVotingEvent.vue?vue&type=script&lang=js"
import style0 from "./DigitalVotingEvent.vue?vue&type=style&index=0&id=2118d108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports